import { render, staticRenderFns } from "./InvoiceItemPriceField.vue?vue&type=template&id=7afa6ede&scoped=true&"
import script from "./InvoiceItemPriceField.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemPriceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa6ede",
  null
  
)

export default component.exports